import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema';


const CommentDialog = ({title, content, open, onClose, onResponse}) => {
    const descriptionElementRef = React.useRef(null);
    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    const sch = (yup) => yup.object({
        description: yup.string().required().min(10).max(200),
    });
    const schema = useYupSchema(sch);


    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
            resolver: yupResolver(schema),
            defaultValues: {
                description: ''
            }
        });


    const close = () => {
        reset();
        onClose();
        onResponse(false, null);
    }

    const onSubmit = (data) => {
        onClose();
        onResponse(true, data.description);
    }



    return(
        <>
            <Dialog
                open={open}  // Controlado completamente por el padre
                onClose={close}
                aria-labelledby="alert-dialog-title"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                    <IconButton
                        aria-label="close"
                        onClick={close}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <form onSubmit={handleSubmit(onSubmit)}
                    style={{
                        width:'100%',
                        height:'100%',
                        display:'flex',
                        flexDirection:'column',
                    }}
                >
                    
                    <DialogContent>
                        {content}
                        <br />
                        <br />
                        <TextField
                            id="outlined-multiline-static"
                            label={t("approvalSongs.reasonDescription")}
                            multiline
                            rows={4}
                            fullWidth
                            {...register('description')}
                            error={!!errors.description}
                            helperText={errors.description?.message}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button type='submit' color="primary" autoFocus>
                            {t("ui.okButton")}
                        </Button>
                        <Button onClick={()=>close()} color="primary">
                            {t("ui.cancelButton")}
                        </Button>
                    </DialogActions>
                
                </form>
            </Dialog>
        </>
    );

}

export default CommentDialog